import { toast as c } from "@systemeio/ui";
import U from "axios";
import { useTranslation as T } from "../../../i18n.mjs";
import { createCanceler as v } from "../utils/create-canceler.mjs";
import { createProgress as w } from "../utils/create-progress.mjs";
import { getMimeType as y } from "../utils/get-mime-type.mjs";
import { useFileUploaderActions as h } from "./use-file-uploader-actions.mjs";
const D = (l) => {
  const { t: s } = T(), { validateAndGetUploadOptions: p, uploadToFileStore: d, activate: m, removeDraftFile: f } = h(l);
  return {
    createFileUploader: (u) => {
      const e = w({ onChange: u }), i = v();
      return {
        progress: e,
        upload: async ({ file: o, source: g }) => {
          e.startProgress();
          const t = i.createToken();
          let a;
          try {
            const { uploadOptions: r, id: n } = await p({
              file: o,
              source: g,
              mimeType: y(o),
              cancelToken: t
            });
            a = n, await d({
              file: o,
              uploadOptions: r,
              progressHandler: e.progressHandler,
              cancelToken: t
            });
            const F = await m({
              fileId: n,
              cancelToken: t
            });
            return e.finishProgress(), F[n];
          } catch (r) {
            if (U.isCancel(r)) {
              c(s("file_manager.cancelled"));
              return;
            }
            throw typeof a == "number" ? await f(a) : c.error(s("file_manager.error")), r;
          }
        },
        cancelUpload: () => {
          i.cancel(), e.resetProgress();
        }
      };
    }
  };
};
export {
  D as useFileUploader
};
